module.exports = __webpack_public_path__ + "img/medal.d9be1c84.png";